// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"72ccd72a","180":"e69719d8","376":"42cb28ec","398":"cad0d31b","517":"23be1277","601":"f0a7a822","669":"3809b2ac","734":"21adac85","825":"dc490a5c"}[chunkId] + ".chunk.js";
};